import { render, staticRenderFns } from "./PriceBook.vue?vue&type=template&id=7360b660&"
import script from "./PriceBook.vue?vue&type=script&lang=js&"
export * from "./PriceBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports